module.exports = __webpack_public_path__ + "static/media/listWhite.1baddece.svg";